import { ReactNode } from "react";
import { CursorPresence } from "@/components/sensory/CursorPresence";
import { WowOnOpen } from "@/components/sensory/WowOnOpen";
import { ClickRipple } from "@/components/motion/ClickRipple";
import { cn } from "@/lib/utils";

interface PublicShellProps {
  children: ReactNode;
  className?: string;
  /** Disable the global click ripple wrapper if a page already provides its own. */
  ripple?: boolean;
  /** Disable the wow-on-open choreography (e.g. for instant-load utility pages). */
  wow?: boolean;
}

/**
 * Wrapper for every public/marketing route. Mounts the sensory layer
 * (cursor presence, first-load choreography, click ripples) so the
 * entire public surface inherits the Phase 4 vocabulary.
 */
export function PublicShell({ children, className, ripple = true, wow = true }: PublicShellProps) {
  const inner = (
    <div className={cn("min-h-screen bg-background text-foreground", className)}>
      {children}
    </div>
  );

  return (
    <>
      <CursorPresence />
      {wow && <WowOnOpen />}
      {ripple ? <ClickRipple className="block w-full">{inner}</ClickRipple> : inner}
    </>
  );
}
